import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import * as Popover from "@radix-ui/react-popover";
import { ChevronDownIcon } from "@/components/Icons/ChevronDownIcon";
import { LANGUAGES } from "@/constants";

export const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    localStorage.setItem("language", languageCode);
    setOpen(false);
  };

  const currentLanguage =
    LANGUAGES.find((lang) => lang.code === i18n.language) || LANGUAGES[0];

  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      <Popover.Trigger asChild>
        <button
          className="group flex items-center gap-1.5 px-2 py-1 rounded-lg hover:bg-white/10 transition-colors"
          aria-label="Select language"
        >
          <span className="text-xl leading-none">{currentLanguage.flag}</span>
          <ChevronDownIcon className="w-3 h-3 text-neutral-300 group-data-[state=open]:rotate-180 transition-transform" />
        </button>
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content
          side="bottom"
          align="end"
          sideOffset={8}
          className="z-[9999] w-[140px] rounded-md border border-white/10 bg-[#242F46] dark:bg-gray-800 p-1 shadow-lg"
        >
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`
                w-full flex items-center gap-2 px-2.5 py-1.5 rounded text-sm transition-all duration-200
                hover:bg-white/10 text-neutral-50
                ${i18n.language === lang.code ? "bg-white/15 font-medium" : ""}
              `}
            >
              <span className="text-lg">{lang.flag}</span>
              <span>{lang.label}</span>
            </button>
          ))}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
